// cspell:ignore couldn
import { createFileRoute } from '@tanstack/react-router';

import { NotFound404 } from '@/components/NotFound404';

export const Route = createFileRoute('/404')({
  component: NotFound404,
});
